export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  children?: NavigationItem[];
  roles?: string[]; // Nueva propiedad para los roles

}

export const NavigationItems: NavigationItem[] = [
  {
    id: 'navigation',
    title: 'Navegación',
    type: 'group',
    icon: 'ti ti-left',
    roles: ['Basic','Admin'],
    children: [
      {
        id: 'sample-page',
        title: 'Inicio',
        type: 'item',
        url: '/sample-page',
        classes: 'nav-item',
        icon: 'ti ti-layout-sidebar'
      },
     
    ]
  },
  {
    id: 'Productos',
    title: 'Consulta',
    type: 'group',
    icon: 'ti ti-left',
    roles: ['Basic','Admin'],
    children: [
      {
        id: 'menu-level',
        title: 'Productos',
        type: 'collapse',  
        roles: ['Basic','Admin'],
        icon: 'ti ti-layout-sidebar',
        children: [
          {
            id: 'menu-upload',
            title: 'Cargar Productos',
            type: 'item',
            url:'/upload-products',
            roles: ['Basic','Admin'],

          },
          {
            id: 'menu-download',
            title: 'Descargar Productos',
            type: 'item',
            url: '/download-products',
            roles: ['Basic','Admin'],

          },
      
        ]
      },
      {
        id: 'profile',
        title: 'Perfil',
        type: 'item',
        url: '/profile',
        roles: ['Basic','Admin'],
        classes: 'nav-item',
        icon: 'ti ti-layout-sidebar'
      },
    ]
  }

];
